/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/27/19
 * Time: 9:53 AM
 */
import * as actionTypes from "./actionTypes";
import Cookies from "js-cookie";
import axios from "../../axios/axios_visitortag";
import axiosTags from "../../axios/axios_tag";
import axios_authentication from "../../axios/axios_authorization";
import {notifyMessage} from "../../const/Common/CommonFunc";
import * as config from "../../const/config/config";
import * as qs from "qs";
import swal from "sweetalert";
import are_you_sure_icon from "../../assets/img/sweet/question.svg";
import {callAllCount} from "./Reception_VisitorCountActions";
import {socketBranchIdStoreHandler} from "./Reception/SocketActions";
import apiConfig from '../../axios/axios_api_services';
import * as keys from "../../const/key/Key";
import * as routeConstants from "../../const/route/Route";

export const receptionAddCustomVisitorsHandler = (data) => {

  return {
    type: actionTypes.CUSTOM_VISITORS,
    value: data
  }
};

export const receptionAllBuildingHandler = (data) => {

  return {
    type: actionTypes.ALL_BUILDINGS,
    value: data
  }
};

export const receptionAllWifiPackageHandler = (data) => {

  return {
    type: actionTypes.ALL_WIFI_PACKAGES,
    value: data
  }
};

export const receptionAllFloorHandler = (data) => {

  return {
    type: actionTypes.ALL_FLOORS,
    value: data
  }
};

export const receptionAllAvailableCardHandler = (data) => {

  return {
    type: actionTypes.ALL_AVAILABLE_CARDS,
    value: data
  }
};

export const callAllBuildings = (usr_obj) => {
  const headers = {
    "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
  };
  let coperateId = usr_obj.corporates[0].corporateId;

  // Get All Buildings Of Corporate
  return dispatch => {
    axiosTags.get(apiConfig.CORPORATE_BUILDINGS(coperateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          dispatch(receptionAllBuildingHandler(response.data.buildingList));
          dispatch(socketBranchIdStoreHandler(response.data.branchId))
        }
      })
      .catch(error => {
        dispatch(checkErrorResponse(error, usr_obj, 1));
      });
  }
};
export const callAllBuildingsByBranchId = (id,userRole) => {
  const headers = {
    "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
  };

  // Get All Buildings Of Corporate
  return dispatch => {
    axiosTags.get(apiConfig.GUEST_GET_ALL_BUILDING_BY_BRANCH(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          dispatch(receptionAllBuildingHandler(response.data.buildingList));
        }
      })
      .catch(error => {
        dispatch(checkErrorResponse(error, id, 4, userRole));
      });
  }
};


export const callAllWifiPackages = (usr_obj) => {
  const headers = {
    "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
  };

  let coperateId = usr_obj.corporates[0].corporateId;
  // Get All Wifi Packges Of Corporate
  return dispatch => {
    axios.get(apiConfig.CORPORATE_SELECT_WIFI_PACKAGES(coperateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          dispatch(receptionAllWifiPackageHandler(response.data.packageList));
        }
      })
      .catch(error => {
        dispatch(checkErrorResponse(error, usr_obj, 2));
      });
  }
};

const emptyFunction = () => {
};


export const checkErrorResponse = (error, usr_obj, type , userRole) => {
  if (error !== undefined) {
    if (error.response === undefined) {
      notifyMessage("Your connection was interrupted!", 1, 3);
      return dispatch => {
        dispatch(emptyFunction);
      }
    } else if (error.response.status === 401) {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "Authorization": "Basic " + config.CLIENT_SECRET
      };
      let refresh_token = Cookies.get('9b8558ba3f051677daf36ebfc67f29fa');

      const data_ = {
        grant_type: "refresh_token",
        refresh_token: refresh_token
      };

      // Get Access token from refresh token
      return dispatch => {
        axios_authentication.post(apiConfig.OAUTH, qs.stringify(data_), {headers: headers})
          .then(response => {
            Cookies.set('68a6102f6ed24899420170004a0273b8', response.data.access_token); //access-token (68a6102f6ed24899420170004a0273b8)
            if (type === 1) {
              dispatch(callAllBuildings(usr_obj));
            } else if (type === 2) {
              dispatch(callAllWifiPackages(usr_obj));
            } else if (type === 3) {
              dispatch(callAllCount(usr_obj));
            } else if (type === 4){
              dispatch(callAllBuildingsByBranchId(usr_obj));
            }

          })
          .catch(error => {

            swal({
              title: "Your token expired! Please re-enter login credentials \n Thank you",
              icon: are_you_sure_icon,
              closeOnClickOutside: false,
              buttons: {
                dangerMode: {
                  text: "Okay",
                  value: "action",
                  className: "warning-btn"
                }
              },
            })
              .then((value) => {
                switch (value) {

                  case "action":
                    Cookies.remove(keys.ACCESS_TOKEN);
                    Cookies.remove(keys.REFRESH_TOKEN);

                    if(userRole === keys.GUEST_USER_USER_ROLE){
                      localStorage.removeItem(keys.GUEST_CACHE);
                      window.location.href = `${routeConstants.GUEST_ROUTE_PATH}/login`;
                    }else{
                      window.location.href = "/";
                    }

                    break;
                  default:
                }
              });
          });
      }
    } else if (error.response.status === 403) {
      notifyMessage("Sorry, your can't access!", 1, 3);
    } else {
      notifyMessage("Your connection was interrupted!", 1, 3);
    }
  } else {
    notifyMessage("Your connection was interrupted!", 1, 3);
  }
};
